import styled from 'styled-components'
import { ToastContainer } from 'react-toastify'

const StyledToastContainer = styled(ToastContainer)`
  .Toastify__toast--success {
    background: #578C6D;
  }
`

export default StyledToastContainer
